export default __webpack_public_path__ + "static/media/business_active.c66fe085.svg";